import { createSlice } from "@reduxjs/toolkit";
import { campaignHandler } from "../services/operations/campaignHandler";

const initialState = {
  campaigns: [],
  status: "idle",
  error: null,
  budget: null,
  currentEditCampaign: null, // Store the campaign being edited
};

// Helper function to normalize placements
const normalizePlacements = (placements) => {
  if (!placements) return [];
  if (Array.isArray(placements)) return placements;
  if (typeof placements === 'string') {
    return placements.split(',').map(p => p.trim());
  }
  return [];
};

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setCurrentEditCampaign: (state, action) => {
      state.currentEditCampaign = action.payload;
    },
    clearCurrentEditCampaign: (state) => {
      state.currentEditCampaign = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(campaignHandler.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(campaignHandler.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        
        // For list action, set the campaigns array
        if (action.payload?.actionType === "list") {
          console.log('Campaign list action received in reducer:', action.payload);
          
          if (Array.isArray(action.payload.data)) {
            console.log('Processing campaign array of length:', action.payload.data.length);
            state.campaigns = action.payload.data.map(campaign => {
              if (!campaign) return null;
              return {
                ...campaign,
                in_content_ad_placements: normalizePlacements(campaign.in_content_ad_placements)
              };
            }).filter(Boolean); // Remove any null entries
            
            console.log('Processed campaigns in reducer:', state.campaigns);
          } else {
            console.error('Campaign data is not an array:', action.payload.data);
            state.campaigns = [];
          }
        }
        // For create/update, update the specific campaign
        else if (action.payload?.actionType === "create" || action.payload?.actionType === "update") {
          const newCampaign = {
            ...action.payload.data,
            in_content_ad_placements: normalizePlacements(action.payload.data.in_content_ad_placements)
          };
          
          if (action.payload.actionType === "create") {
            state.campaigns = [...state.campaigns, newCampaign];
          } else {
            state.campaigns = state.campaigns.map(c => 
              c.campaign_id === newCampaign.campaign_id ? newCampaign : c
            );
          }
        }
      })
      .addCase(campaignHandler.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

  },
});

export const { setCurrentEditCampaign, clearCurrentEditCampaign } = campaignSlice.actions;

export default campaignSlice.reducer;